import YTPlayer from '../../scripts/components/YTPlayer';
import { initCopyDiscountCode } from '../../snippets/discount-code-promo/discount-code-promo';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

YTPlayer.init();
initCopyDiscountCode();
initCollapsibleRows();
